import { render, staticRenderFns } from "./enterNewPersonnelData.vue?vue&type=template&id=2affc40a&scoped=true&"
import script from "./enterNewPersonnelData.vue?vue&type=script&lang=js&"
export * from "./enterNewPersonnelData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2affc40a",
  null
  
)

export default component.exports